import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-cropper';
import { connect } from 'react-redux';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

import { buttons as Buttons } from '@breezeway/brzw-components';
import { getActiveDimensions } from '@shared/active_resize_listener/selectors';
import AddPhotoButton from '../add_photo_button';
import { DIMENSION_STATES } from '../../../utils/dimension';

import 'cropperjs/dist/cropper.css';
import './image_crop.scss';

class ImageCrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cropData: null,
      fileData: null,
    };

    this.cancel = this.cancel.bind(this);
    this.crop = this.crop.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.renderPhotoUploader = this.renderPhotoUploader.bind(this);
    this.saveCrop = this.saveCrop.bind(this);
    this.setFileData = this.setFileData.bind(this);
  }

  onDrop(files) {
    const filesWithPreview = _.map(files, file => {
      file.preview = window.URL.createObjectURL(file);
      return file;
    });
    const reader = new FileReader();
    reader.onloadend = () => this.setFileData(reader.result);
    reader.readAsDataURL(filesWithPreview[0]);
  }

  setFileData(fileData) {
    this.setState({ fileData });
  }

  crop() {
    this.cropper.getCroppedCanvas().toBlob(blob => this.setState({ cropData: blob }));
  }

  saveCrop() {
    this.props.saveImage(this.state.cropData);
  }

  cancel() {
    this.setState({
      fileData: null,
      cropData: null,
    });
    this.props.cancel();
  }

  renderPhotoUploader() {
    const { isMobile } = this.props;

    if (isMobile) {
      return (
        <AddPhotoButton onDrop={this.onDrop} className="element__add-photo-wrapper">
          <Buttons.TextButton
            size={Buttons.constants.BUTTON_SIZES.LARGE}
            theme={Buttons.constants.BUTTON_THEMES.SECONDARY}
          >
            Add Photos
          </Buttons.TextButton>
        </AddPhotoButton>
      );
    }

    return (
      <Dropzone accept="image/jpeg, image/png" multiple onDrop={this.onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div
            {...getRootProps()}
            className={classnames('photo-dropzone', { drag_hovering: isDragActive })}
          >
            <input {...getInputProps()} />
            <h4>DROP PHOTO HERE</h4>
            <p className="link">OR UPLOAD YOUR IMAGE FILE</p>
          </div>
        )}
      </Dropzone>
    );
  }

  renderAddButton() {
    const { asDraggable } = this.props;

    if (asDraggable) {
      return this.renderPhotoUploader();
    }

    return (
      <AddPhotoButton onDrop={this.onDrop} multiple={false}>
        + Add company logo
      </AddPhotoButton>
    );
  }

  render() {
    const { aspectRatio, buttonLabel, cancelLabel, error, height, width } = this.props;
    const { fileData } = this.state;
    return (
      <div>
        {!fileData ? (
          this.renderAddButton()
        ) : (
          <div>
            <Cropper
              ref={cropper => {
                this.cropper = cropper;
              }}
              src={fileData}
              style={{
                height,
                maxWidth: '100%',
                width,
              }}
              aspectRatio={aspectRatio}
              guides={false}
              crop={this.crop}
            />

            <div className="image-crop__buttons">
              <Buttons.TextButton
                theme={Buttons.constants.BUTTON_THEMES.SECONDARY}
                onClick={this.cancel}
              >
                {cancelLabel}
              </Buttons.TextButton>
              <Buttons.TextButton
                theme={Buttons.constants.BUTTON_THEMES.PRIMARY}
                onClick={this.saveCrop}
              >
                {buttonLabel}
              </Buttons.TextButton>
            </div>
          </div>
        )}

        {error && <div className="error-message">{error}</div>}
      </div>
    );
  }
}

ImageCrop.propTypes = {
  asDraggable: PropTypes.bool,
  aspectRatio: PropTypes.number,
  buttonLabel: PropTypes.string,
  cancel: PropTypes.func,
  cancelLabel: PropTypes.string,
  error: PropTypes.string,
  height: PropTypes.number,
  isMobile: PropTypes.bool,
  saveImage: PropTypes.func,
  width: PropTypes.number,
};

ImageCrop.defaultProps = {
  asDraggable: false,
  buttonLabel: 'Save',
  cancelLabel: 'Cancel',
  height: 400,
  width: 600,
};

const mapStateToProps = state => ({
  isMobile: getActiveDimensions(state).state === DIMENSION_STATES.MOBILE,
});

export default connect(mapStateToProps)(ImageCrop);
